import { combineReducers } from "@reduxjs/toolkit";

import salesRecommendation from "./salesRecommendationReducer";

export default combineReducers({
  salesRecommendation
});
